export default "__VITE_ASSET__C4pzDKCX__"